/**
 * @overview 场地使用记录管理（场地核实）
 * @author jzhu
 * @date 2020-8-20
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, utils_tool } from '../../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool
let { Storage } = utils_tool

class SiteOrderCheck extends WizContainer {

    componentName = 'SiteOrderCheck'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _userInfo = () => {
        let user = Storage.getStorage('user') || {}
        return user
    }

    _check = (nextProps, nextState, key) => {
        let o = nextProps[key]
        if (o.success) {
            wizNotice.success('操作成功')
        } else {
            wizNotice.error(o.msg)
        }
        return true
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig,
            apiDataFormat: {
                check: this._check
            },
            self: this
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(SiteOrderCheck)
